import { NOT_FOUND } from "redux-first-router";

import { RoutesMapWithLazyThunk } from "../router-thunks/injectThunks";
import { RouteName } from "./types";

export const ROUTING_CONFIG: RoutesMapWithLazyThunk = {
  [RouteName.Catalog]: {
    path: "/catalog/:tab?",
    thunks: ["currentProject"],
  },
  [RouteName.Feedback]: "/feedback",
  [RouteName.Help]: "/help/get-started",
  [RouteName.Style]: {
    path: "/:project/style/:layer",
    thunks: ["currentProject"],
  },
  [RouteName.StyleEditor]: {
    path: "/:project/style-editor/:layer",
    thunks: ["currentProject"],
  },
  [RouteName.Dashboard]: {
    path: "/:project/dashboard/:layer",
    thunks: ["currentProject"],
  },
  [RouteName.Presentation]: {
    path: "/:project/presentation/:layer",
    thunks: ["currentProject"],
  },
  [RouteName.LayerConfiguration]: {
    path: "/:project/layer-configuration/:layer",
    thunks: ["currentProject"],
  },
  [RouteName.ProjectConfiguration]: {
    path: "/:project/project-configuration",
    thunks: ["currentProject"],
  },
  [RouteName.EqlQuery]: {
    path: "/:project/eql-query",
    thunks: ["currentProject"],
  },
  [RouteName.SymbolLibrary]: {
    path: "/:project/symbol-library/:layer/:index?",
    thunks: ["currentProject"],
  },
  [RouteName.Main]: {
    path: "/:project?/:panel?",
    thunks: ["currentProject"],
  },
  [NOT_FOUND]: {
    path: "/not-found",
    thunks: ["404"],
  },
};

export const SHARED_ROUTING_CONFIG: RoutesMapWithLazyThunk = {
  [RouteName.Main]: {
    path: "/:sharedMap?/layers",
    thunks: ["currentProject"],
  },
};
